var map = {
	"./background.svg": "0581",
	"./banner.jpg": "301c7",
	"./banner1.jpg": "d15f",
	"./banner2.jpg": "db49",
	"./banner2.png": "8813",
	"./barcode.png": "48b6",
	"./contact.png": "dfe7",
	"./goldpostlogo.png": "aa41",
	"./hoplucpostlogo.png": "15b2",
	"./hoplucpostlogowhite.png": "0059",
	"./icon-cho-lay.png": "2ff1",
	"./icon-chuyen-hoan.png": "d582",
	"./icon-dang-hoan.png": "cf27",
	"./icon-di-phat.png": "1b02",
	"./icon-huy-don.png": "6552",
	"./icon-lay-hang.png": "01ad",
	"./icon-phat-thanh-cong.png": "9c4b",
	"./icon-su-co.png": "17bb",
	"./logo-ant.svg": "b1e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";